import { GenericStore } from 'common/types/generic-store-state.types';
import { StoreApi } from 'zustand';
import { isDevEnv } from 'utils/is-dev-env';

type ConnectFn = (s: StoreApi<GenericStore>) => void;

export const connectToDevtools = (store: StoreApi<GenericStore>) => {
  if (isDevEnv) {
    import('./redux-devtools-connection')
      .then((module) => {
        const connectToReduxDevtools: ConnectFn = module.default;
        connectToReduxDevtools(store);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Unable to import redux devtools connection module', err);
      });
  }
};
